function matchHeight(selector) {
  const items = document.querySelectorAll(selector);
  if (!items.length) return;

  let maxHeight = 0;

  // reset height
  items.forEach(item => {
    item.style.height = 'auto';
  });

  // get max height
  items.forEach(item => {
    maxHeight = Math.max(maxHeight, item.offsetHeight);
  });

  // apply height
  items.forEach(item => {
    item.style.height = maxHeight + 'px';
  });
}

// on load
window.addEventListener('load', function () {
  matchHeight('.match-height');
  matchHeight('.library-title-match-height');
  
});

// on resize
window.addEventListener('resize', function () {
  matchHeight('.match-height');
  matchHeight('.library-title-match-height');
});

const menuIcon = document.querySelector('.top-bar__menu-icon');
const menuBlock = document.querySelector('.top-bar__menu-block');

// Toggle menu on icon click
menuIcon.addEventListener('click', (e) => {
  e.stopPropagation();
  menuIcon.classList.toggle('active');
  menuBlock.classList.toggle('active');
});

// Close menu on outside click
document.addEventListener('click', () => {
  menuIcon.classList.remove('active');
  menuBlock.classList.remove('active');
});

// Prevent closing when clicking inside menu
menuBlock.addEventListener('click', (e) => {
  e.stopPropagation();
});


document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    menuIcon.classList.remove('active');
    menuBlock.classList.remove('active');
  }
});



(function () {

  function skioFormsStyle_apply() {
    try {
      const el = document.querySelector('shopify-forms-embed');

      if (!el) return false;

      // Shadow root might not be ready immediately
      if (!el.shadowRoot) return false;

      // Prevent duplicate injection
      if (el.shadowRoot.querySelector('#custom-forms-style')) return true;

      const style = document.createElement('style');
      style.id = 'custom-forms-style';

      style.textContent = `
        #app-embed input._formInputField_nag3b_7, 
        #app-embed input._formPhoneInputField_piv1u_17 {
          border-radius: 500px !important;
        }

        #app-embed form._formFieldset_cit2d_82 {
          gap: 20px !important;
        }

        #app-embed  ._selectToggle_12thd_25 {
          border-radius: 500px !important;
        }

        #app-embed ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          max-width: 78rem !important;
        }
      
        #app-embed button._formSubmitButton_cit2d_96 {
          font-family: var(--font-heading-family) !important;
          font-weight: 500 !important;
          font-size: 16px !important;
          line-height: 100% !important;
          letter-spacing: 0 !important;
          text-align: center !important;
          border-radius: var(--buttons-radius-outset) !important;
          left: calc(var(--inputs-border-width) + 2rem) !important;
          top: calc(1rem + var(--inputs-border-width))!important;
        }

        #app-embed ._formInputFieldLabel_1mxsl_38 {
          font-size: 1.6rem !important;
          letter-spacing: .1rem !important;
          font-family: var(--font-body-family) !important;
          color: rgba(var(--color-foreground))!important;
        }

        #app-embed ._formFieldContainer_1mxsl_5 textarea {
          border-radius: 20px !important;
        }

        #app-embed ._formFieldContainer_1mxsl_5:has(textarea)::before {
          content: none !important;
        }

        #app-embed ._label_12thd_10._textBody_2aowh_10 {
          text-align: left !important;
          font-size: 1.6rem !important;
          letter-spacing: .1rem !important;
          font-family: var(--font-body-family) !important;
          color: rgba(var(--color-foreground))!important;
        }

        #app-embed ._textHeading_2aowh_35 {
          font-family: var(--font-heading-family) !important;;
          font-weight: 600 !important;
          font-size: 42px !important;
          line-height: 100% !important;
          letter-spacing: 0 !important;
          margin-bottom: 2rem !important;
        }
        
        #app-embed ._textBody_2aowh_10 p {
          font-family: var(--font-body-family) !important;
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 100% !important;
          letter-spacing: 0 !important;
        }

        #app-embed ._checkboxFieldSet_1hja3_3 legend {
          display: none !important;
        }

        #app-embed ._checkboxField_1hja3_3 ._textBody_2aowh_10 {
          font-family: var(--font-body-family) !important;
          font-weight: 400 !important;
          font-size: 18px !important;
          line-height: 160%!important;
          letter-spacing: 0!important;
        }

        @media screen and (max-width: 768px) {
           #app-embed ._textHeading_2aowh_35 { 
             font-size: 30px !important;
           }
        }
        


      `;

      el.shadowRoot.prepend(style);

      console.log('Shopify Forms style injected');
      return true;

    } catch (err) {
      console.error('Forms styling error:', err);
      return true; // stop retrying if error
    }
  }

  // ---- Retry until shadowRoot is ready ----
  function skioFormsStyle_waitForEmbed() {

    const interval = setInterval(() => {
      const done = skioFormsStyle_apply();

      if (done) {
        clearInterval(interval);
      }
    }, 300);

    // Safety timeout (stop after 10s)
    setTimeout(() => clearInterval(interval), 10000);
  }

  // ---- Start when DOM changes ----
  const observer = new MutationObserver(() => {
    const el = document.querySelector('shopify-forms-embed');
    if (el) {
      observer.disconnect();
      skioFormsStyle_waitForEmbed();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();



// Header Dropdown on hover

(function () {
  var HOVER_DELAY = 150; // ms — prevents flicker on accidental mouse-overs

  function initHoverMenus() {
    var details = document.querySelectorAll('.header__menu-item-1');

    details.forEach(function (summary) {
      var detail = summary.closest('details');
      if (!detail) return;

      var closeTimer;
      var openTimer;

      // ── OPEN on mouse enter (on the summary) ──────────────────────────
      summary.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          closeAllExcept(detail);
          openDropdown(detail);
        }, HOVER_DELAY);
      });

      // ── KEEP OPEN when mouse moves into the submenu ───────────────────
      var submenu = detail.querySelector('.header__submenu');
      if (submenu) {
        submenu.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });

        submenu.addEventListener('mouseleave', function () {
          closeTimer = setTimeout(function () {
            closeDropdown(detail);
          }, HOVER_DELAY);
        });
      }

      // ── CLOSE when mouse leaves the summary ───────────────────────────
      summary.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          closeDropdown(detail);
        }, HOVER_DELAY);
      });
    });

    // ── CLOSE all when mouse leaves the entire header ─────────────────
    var header = document.querySelector('.header__inline-menu, header');
    if (header) {
      header.addEventListener('mouseleave', function () {
        closeAll();
      });
    }
  }

  function openDropdown(detail) {
    detail.setAttribute('open', '');
    var summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown(detail) {
    detail.removeAttribute('open');
    var summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    document.querySelectorAll('.header__menu-item-1').forEach(function (summary) {
      var detail = summary.closest('details');
      if (detail) closeDropdown(detail);
    });
  }

  function closeAllExcept(current) {
    document.querySelectorAll('.header__menu-item-1').forEach(function (summary) {
      var detail = summary.closest('details');
      if (detail && detail !== current) closeDropdown(detail);
    });
  }

  // ── Init on DOM ready ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();

// /**

//  * - On variant change: hide/show ATC if variant already in cart
//  * - If ANY tab updates cart via /cart/add|update|change: ALL open tabs refresh their state
//  *
//  * How:
//  * 1) In each tab, monkey-patch fetch + XHR to detect cart mutations.
//  * 2) When detected, broadcast a "cart:changed" message via BroadcastChannel (or localStorage fallback).
//  * 3) All tabs listen and re-fetch /cart.json, then update UI.
//  */
(() => {
  const CHANNEL_NAME = "cart-sync-v1";
  const MUTATION_RE = /\/cart\/(add|update|change)(?:\.js|\.json)?/i;

  // ---- cross-tab
  const bc = "BroadcastChannel" in window ? new BroadcastChannel(CHANNEL_NAME) : null;

  function broadcastCartChanged() {
    const payload = { type: "cart:changed", ts: Date.now() };
    if (bc) bc.postMessage(payload);
    else localStorage.setItem(CHANNEL_NAME, JSON.stringify(payload));
  }

  function onCrossTabMessage(handler) {
    if (bc) {
      bc.addEventListener("message", (e) => handler(e.data));
    } else {
      window.addEventListener("storage", (e) => {
        if (e.key !== CHANNEL_NAME || !e.newValue) return;
        try { handler(JSON.parse(e.newValue)); } catch (_) {}
      });
    }
  }

  // ---- state
  const state = {
    currentVariantId: null,
    cart: null,
    cartFetchInFlight: null,
  };

  function debounce(fn, wait = 150) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  function getCurrentVariantIdFromDOM() {
    // Works on most Shopify product forms
    const input =
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]');

    const id = Number(input?.value);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  async function fetchCartOnce(force = false) {
    if (!force && state.cartFetchInFlight) return state.cartFetchInFlight;

    state.cartFetchInFlight = (async () => {
      const res = await fetch("/cart.json", {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!res.ok) throw new Error("Failed to fetch /cart.json");
      const cart = await res.json();
      state.cart = cart;
      return cart;
    })();

    try {
      return await state.cartFetchInFlight;
    } finally {
      state.cartFetchInFlight = null;
    }
  }

  function updateButtons(isVariantInCart) {
    const btnWrap = document.querySelector(".product .product-form__buttons");
    if (!btnWrap) return;
    btnWrap.classList.toggle("visually-hidden", !!isVariantInCart);
  }

  function hasSampleProperty(properties) {
    const marker = "_sample product";

    if (!properties) return false;

    // Shopify cart.json: properties is typically an object { key: value }
    return Object.entries(properties).some(([k, v]) => {
      const kk = String(k ?? "").toLowerCase();
      const vv = String(v ?? "").toLowerCase();
      return kk.includes(marker) || vv.includes(marker);
    });
  }


  const refreshUIUsingCachedCart = debounce(async () => {
    // IMPORTANT: fallback if variantChange didn’t fire (common on initial load / other-tab change)
    if (!state.currentVariantId) state.currentVariantId = getCurrentVariantIdFromDOM();
    if (!state.currentVariantId) return;

    if (!state.cart) await fetchCartOnce();

    const items = Array.isArray(state.cart?.items) ? state.cart.items : [];
    // const inCart = items.some(
    //   (item) => Number(item.variant_id) === Number(state.currentVariantId)
    // );

    const inCart = items.some((item) => {
      const sameVariant = Number(item?.variant_id) === Number(state.currentVariantId);
      if (!sameVariant) return false;

      return hasSampleProperty(item?.properties);
    });


    updateButtons(inCart);
  }, 50);

  const refetchCartAndRefreshUI = debounce(async () => {
    await fetchCartOnce(true); // force refresh after a mutation
    await refreshUIUsingCachedCart();
  }, 150);

  // ---- patch fetch/xhr to detect mutations and update cache
  function patchFetch() {
    const origFetch = window.fetch;
    if (!origFetch || origFetch.__cartPatched) return;

    const wrapped = async function (...args) {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      const res = await origFetch.apply(this, args);

      if (MUTATION_RE.test(url) && res.ok) {
        broadcastCartChanged();
        refetchCartAndRefreshUI();
      }
      return res;
    };

    wrapped.__cartPatched = true;
    window.fetch = wrapped;
  }

  function patchXHR() {
    const origOpen = XMLHttpRequest.prototype.open;
    if (origOpen.__cartPatched) return;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__cartUrl = url;
      return origOpen.call(this, method, url, ...rest);
    };

    const origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener("loadend", () => {
        const url = this.__cartUrl || "";
        if (MUTATION_RE.test(url) && this.status >= 200 && this.status < 300) {
          broadcastCartChanged();
          refetchCartAndRefreshUI();
        }
      });
      return origSend.apply(this, args);
    };

    origOpen.__cartPatched = true;
  }

  patchFetch();
  patchXHR();

  // OTHER tabs changing the cart
  onCrossTabMessage((msg) => {
    if (msg?.type !== "cart:changed") return;
    // ensure we have a variant id before refresh
    if (!state.currentVariantId) state.currentVariantId = getCurrentVariantIdFromDOM();
    refetchCartAndRefreshUI();
  });

  // Variant change event (if your theme provides it)
  if (typeof subscribe === "function" && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
      const variantId =
        Number(evt?.data?.variant?.id) ||
        Number(evt?.data?.variantId) ||
        Number(evt?.data?.id);

      if (!variantId) return;
      state.currentVariantId = variantId;
      refreshUIUsingCachedCart();
    });
  }

  // In case theme re-renders product form / hidden variant input without firing variantChange
  const mo = new MutationObserver(() => {
    const domVariantId = getCurrentVariantIdFromDOM();
    if (domVariantId && domVariantId !== state.currentVariantId) {
      state.currentVariantId = domVariantId;
      refreshUIUsingCachedCart();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Initial
  state.currentVariantId = getCurrentVariantIdFromDOM();
  fetchCartOnce()
    .then(() => refreshUIUsingCachedCart())
    .catch(() => {});
})();




/**
 * Independent utility:
 * After ANY /cart/add|update|change request completes, it:
 * 1) fetches /cart.json
 * 2) finds line items whose properties contain "_sample product" and quantity > 1
 * 3) shows a toast: "You cannot add more than 1 quantity per sample variant"
 * 4) clamps those line items to quantity = 1 using /cart/change.js (by line item key)
 */
(function sampleQtyClampWatcher() {
  const MUTATION_RE = /\/cart\/(add|update|change)(?:\.js|\.json)?/i;
  const SAMPLE_MARKER = "_sample product";
  const TOAST_MSG = "You cannot add more than 1 quantity per sample variant";

  // Prevent infinite loops when we call /cart/change.js ourselves
  let isApplyingClamp = false;

  // Avoid spamming toasts if multiple requests fire quickly
  let lastToastAt = 0;
  const TOAST_COOLDOWN_MS = 2500;

  function showToast(message) {
    const now = Date.now();
    if (now - lastToastAt < TOAST_COOLDOWN_MS) return;
    lastToastAt = now;

    // Create container once
    let container = document.getElementById("sample-qty-toast-container");
    if (!container) {
      container = document.createElement("div");
      container.id = "sample-qty-toast-container";
      container.setAttribute("aria-live", "polite");
      container.style.cssText = [
        "position:fixed",
        "z-index:999999",
        "left:50%",
        "bottom:24px",
        "transform:translateX(-50%)",
        "display:flex",
        "flex-direction:column",
        "gap:8px",
        "pointer-events:none",
      ].join(";");
      document.body.appendChild(container);
    }

    const toast = document.createElement("div");
    toast.role = "status";
    toast.textContent = message;
    toast.style.cssText = [
      "max-width:min(560px, calc(100vw - 32px))",
      "background:rgba(20,20,20,0.95)",
      "color:#fff",
      "padding:12px 14px",
      "border-radius:10px",
      "box-shadow:0 8px 24px rgba(0,0,0,0.25)",
      "font-size:14px",
      "line-height:1.35",
      "opacity:0",
      "transform:translateY(6px)",
      "transition:opacity 180ms ease, transform 180ms ease",
      "pointer-events:none",
    ].join(";");

    container.appendChild(toast);

    // animate in
    requestAnimationFrame(() => {
      toast.style.opacity = "1";
      toast.style.transform = "translateY(0)";
    });

    // animate out + remove
    const DISPLAY_MS = 2600;
    setTimeout(() => {
      toast.style.opacity = "0";
      toast.style.transform = "translateY(6px)";
      setTimeout(() => toast.remove(), 220);
    }, DISPLAY_MS);
  }

  function propertiesContainMarker(properties) {
    if (!properties) return false;

    // cart.json returns `properties` as an object: {key: value}
    if (typeof properties === "object") {
      for (const [k, v] of Object.entries(properties)) {
        if (String(k).toLowerCase().includes(SAMPLE_MARKER)) return true;
        if (String(v).toLowerCase().includes(SAMPLE_MARKER)) return true;
      }
      return false;
    }

    return String(properties).toLowerCase().includes(SAMPLE_MARKER);
  }

  async function fetchCart() {
    const res = await fetch("/cart.json", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("Failed to fetch /cart.json");
    return res.json();
  }

  async function changeLineQuantityByKey(lineKey, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    if (!res.ok) throw new Error("Failed to call /cart/change.js");
    return res.json();
  }

  async function clampSampleLinesToOne() {
    if (isApplyingClamp) return;

    try {
      const cart = await fetchCart();
      const items = Array.isArray(cart.items) ? cart.items : [];

      const offenders = items.filter(
        (item) =>
          item &&
          item.key &&
          Number(item.quantity) > 1 &&
          propertiesContainMarker(item.properties)
      );

      if (!offenders.length) return;

      // Tell user (once per cooldown window)
      showToast(TOAST_MSG);

      isApplyingClamp = true;

      // Clamp each offending line to qty=1
      for (const item of offenders) {
        await changeLineQuantityByKey(item.key, 1);
      }
    } catch (err) {
      console.error("[SampleQtyClamp] Failed:", err);
    } finally {
      isApplyingClamp = false;
    }
  }

  function installNetworkWatcher() {
    // --- watch fetch
    const origFetch = window.fetch;
    if (origFetch && !origFetch.__sampleClampPatched) {
      const wrappedFetch = async function (...args) {
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
        const res = await origFetch.apply(this, args);

        if (!isApplyingClamp && MUTATION_RE.test(url) && res && res.ok) {
          clampSampleLinesToOne();
        }
        return res;
      };
      wrappedFetch.__sampleClampPatched = true;
      window.fetch = wrappedFetch;
    }

    // --- watch XHR
    const origOpen = XMLHttpRequest.prototype.open;
    if (!origOpen.__sampleClampPatched) {
      const origSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this.__sampleClampUrl = url;
        return origOpen.call(this, method, url, ...rest);
      };

      XMLHttpRequest.prototype.send = function (...args) {
        this.addEventListener("loadend", () => {
          const url = this.__sampleClampUrl || "";
          if (
            !isApplyingClamp &&
            MUTATION_RE.test(url) &&
            this.status >= 200 &&
            this.status < 300
          ) {
            clampSampleLinesToOne();
          }
        });
        return origSend.apply(this, args);
      };

      origOpen.__sampleClampPatched = true;
    }
  }

  installNetworkWatcher();

  // Expose if you want to call it manually
  window.clampSampleLinesToOne = clampSampleLinesToOne;
})();
